import { Button } from "react-bootstrap";
import { AuthorizationList, CanAccess } from "../../components/template/authorization/Authorization";

const buttonActionStyle = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

export const initFilterInput = {
  searchName: "",
  transactionStartDate: null,
  transactionEndDate: null,
  page: 1,
  pageSize: 10,
  sortingField: "",
  sortingOrder: "",
};

export const paymentOption = [
  { value: "cash", label: 'Tunai' },
  { value: "transfer", label: 'Non-Tunai' }
];

export const initProcessData = {
  bankName: "",
  transferProof: "",
};

export const renderLoanNonCashColumns = (
  handleProcessButtonClick,
  handleRejectButtonClick
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "create_at",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "9%",
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
      width: "11%",
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
      width: "11%",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "ktp_name",
      title: "Nama Nasabah",
      sorter: true,
      width: "15%",
    },
    {
      dataIndex: "transferFee",
      key: "transferFee",
      title: "Biaya Transfer",
      width: "10%",
    },
    {
      dataIndex: "amountReceived",
      key: "amountReceived",
      title: "Jumlah Diterima",
      width: "10%",
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      backend_key: "office_account_name",
      title: "Nama Rekening",
      sorter: true,
      width: "15%",
    },
    {
      dataIndex: "bankOrAccountNumber",
      key: "bankOrAccountNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "validityProof",
      key: "validityProof",
      title: "Surat Keabsahan",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "7%",
      render: (_, record) => (
        <CanAccess
          role={AuthorizationList.update_manual_transfer}
          yes={
            <div style={buttonActionStyle}>
              <Button
                variant="primary"
                className="btn-action btn-detail"
                onClick={() => handleProcessButtonClick(record)}
              >
                Proses
              </Button>
              <Button
                variant="danger"
                className="btn-action btn-delete"
                danger
                onClick={() => handleRejectButtonClick(record.gadaiID)} // record.transactionID
              >
                Batalkan
              </Button>
            </div>
          }
        />
      ),
    },
  ];
};

export const renderPaymentNonCashColumns = (
  handleAcceptButtonClick,
  handleRejectButtonClick
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      title: "Tanggal & Waktu",
      sorter: (a, b) => a.dateTime.length - b.dateTime.length,
      width: "9%",
    },
    {
      dataIndex: "sbg",
      key: "sbg",
      title: "No. Surat Bukti Gadai",
      width: "11%",
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
      width: "11%",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
      sorter: (a, b) => a.customerName.length - b.customerName.length,
      width: "15%",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah Tagihan",
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      title: "Nama Rekening",
      sorter: (a, b) => a.accountName.length - b.accountName.length,
      width: "15%",
    },
    {
      dataIndex: "bankOrAccountNumber",
      key: "bankOrAccountNumber",
      title: "Bank/No. Rekening",
    },
    {
      dataIndex: "transferProof",
      key: "transferProof",
      title: "Bukti Transfer",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "7%",
      render: (_, record) => (
        <div style={{ gap: "10px" }}>
          <Button
            style={{ width: 80 }}
            variant="primary"
            className="btn-action btn-detail"
            onClick={() => handleAcceptButtonClick(record.gadaiID)} // record.transactionID
          >
            Terima
          </Button>
          <Button
            style={{ width: 80 }}
            variant="danger"
            className="btn-action btn-delete mt-1"
            danger
            onClick={() => handleRejectButtonClick(record.gadaiID)} // record.transactionID
          >
            Tolak
          </Button>
        </div>
      ),
    },
  ];
};
